import React from 'react';
import { Analytics } from '@vercel/analytics/react';
import './App.css';
import Navbar from './components/Navbar';
import Header from './components/Header';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';

const App = () => {
  return (
    <>
      <div className="App">
        <Navbar />
        <main>
          <Header />
          <About />
          <Projects />
          <Contact />
        </main>
        <Footer />
      </div>
      <Analytics />
    </>
  );
};

export default App;